import { ROUTES } from '../route/routes';
import newIcon from '../assets/icons/statusnew.svg';
import pendingIcon from '../assets/icons/statuspending.svg';
import evaluatedIcon from '../assets/icons/statusevaluated.svg';
import missedIcon from '../assets/icons/statusmissed.svg';
import submittedIcon from '../assets/icons/statussubmitted.svg';

export const LOCAL_STORAGE_KEYS = {
  AUTH_KEY: 'auth',
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  UPCOMING_CLASS_INFO: 'upcoming_class_info',
  USER_TYPE: 'user_type',
  USER_ID: 'user_id',
  OTP_SENT_AT: 'otp_sent_at',
  OTP_ATTEMPTS_LEFT: 'otp_attempts_left',
  IS_ONBOARDING: 'is_onboarding',
  LOGIN_BRAND: 'login_brand',
  USER_BU_ID: 'user_bu_id',
  BRAND_LOGO: 'brand_logo',
  BRAND_LOGO_WEB: 'brand_logo_web',
  BRAND_LOGO_MOBILE: 'brand_logo_mobile',
  BRAND_FAVICON: 'brand_favicon',
  BRAND_ASSETS_BU_ID: 'brand_assets_bu_id',
};

export const SESSION_STORAGE_KEYS = {
  SPARKY_SESSIONS_SELECTED_COURSE: 'sparkySessions_selectedCourse',
  SPARKY_SESSIONS_SELECTED_TAB: 'sparkySessions_selectedTab',
};

export const STATUS_CODES = {
  SUCCESS_STATUS: 200,
  RECORD_CREATED: 201,
  NOT_FOUND: 404,
  TOO_MANY_REQUESTS: 429,
  UNAUTHORIZED_USER: 401,
};

export const API_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

export const COLOR_MODES = {
  LIGHT: 'light',
  DARK: 'dark',
};

// Please move the below variable once localisation is introduced
export const GENERIC_GET_API_FAILED_ERROR_MESSAGE =
  'Something went wrong! Please try again later';

export const NAVIGATION_CONSTANTS = {
  DASHBOARD: `${ROUTES.DASHBOARD}`,
  LIVE_CLASSES: `${ROUTES.CLASSES}`,
  ASSIGNMENTS: ROUTES.ASSIGNMENTS,
  TESTS: ROUTES.TESTS,
  REPORTS: ROUTES.REPORTS,
  SKILLS: ROUTES.SKILLS,
  SPARKY_SESSIONS: ROUTES.SPARKY_SESSIONS,
  PRACTICE: ROUTES.PRACTICE,
  LEARNING_ZONE: ROUTES.LEARNING_ZONE,
  SAT_DASHBOARD: ROUTES.SAT_DASHBOARD,
};

export const DEFAULT_PROFILE_RING = { SIZE: 125, THICKNESS: 2.2 };



// Test-related constants
export const TESTS_STATUS = {
  ALL: 'All',
  PAST_TESTS: 'Past Tests',
  MISSED: 'Missed',
};

export const SESSION_TYPE_STRING = {
  PROCTOR_TEST: 'proctor_test',
  NON_PROCTOR_TEST: 'non_proctor_test',
};

export const API_RESPONSE_STATUS_CODE = {
  SUCCESS: 1,
  FAILURE: 0,
};


export const NOTIFICATION_TYPES = {
  NEW_ASSIGNED: 'assigned',
  ASSINGMENT_REVIEWED: 'reviewed',
};

export const ASSIGNMENT_STATUS = {
  ALL: 'All',
  COMPLETED: 'Evaluated',
  MISSED: 'Missed!',
  NEW: 'New',
  PENDING: 'Pending',
  SUBMITTED: 'Submitted',
  UNDER_REVIEW: 'Under Review',
};

export const DEFAULT_SETTINGS = {
  PAGE_NO: 1,
  PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 200,
};

export const URL_PARAMS = {
  ASSIGNMENT_TYPE: 'assignment-type',
  ASSIGNMENT_ID: 'assignment-id',
  ASSIGNMENT_STATUS: 'assignment-status',
  CHAPTER_STRENGTH_SUBJECT: 'chapter-strength-subject',
  CLASS_ID: 'class-id',
  CLASS_LIST_TYPE: 'class-type',
  COURSE_ID: 'courseId',
  COURSE_NAME: 'course',
  GRADE: 'grade',
  LIVE_TEST_ID: 'live-test-id',
  NOTIFICATION_ASSIGNMENT_ID: 'notifcation-assignment-id',
  SHOW_PRE_READ: 'show-nearest-upcoming-class-pre-read',
  SHOW_PICK_AVATER_VIEW: 'pick-avatar',
  SORT_BY: 'sort-by',
  SUBJECT_ID: 'subject-id',
  TIMELINE_SUBJECT: 'timeline-subject',
  VIEW_BY: 'view-by',
  TESTS_STATUS: 'tests-status',
  SESSION_TYPE: 'session-type',
  VIEW: 'view',
};

export const CLASS_STATUS = {
  ALL: 'all',
  COMPLETED: 'completed',
  UPCOMING: 'upcoming',
};

export const GRADES_LIST = [
  { id: 1, grade: 'A+' },
  { id: 2, grade: 'A' },
  { id: 3, grade: 'B+' },
  { id: 4, grade: 'B' },
  { id: 5, grade: 'C+' },
  { id: 6, grade: 'C' },
  { id: 7, grade: 'D+' },
  { id: 8, grade: 'D' },
  { id: 9, grade: 'E' },
  { id: 10, grade: 'F' },
];

export const GRADES_NOTATION = {
  'A+': 'a-plus',
  A: 'a',
  'B+': 'b-plus',
  B: 'b',
  'C+': 'c-plus',
  C: 'c',
  'D+': 'd-plus',
  D: 'd',
  E: 'e',
  F: 'f',
};

export const SLIDE_BY = 500;

export const TAB_BREAKPOINT = 1366;

export const ASSIGNMENT_DETAIL_VIEW = {
  ASSIGNMENT: 'assigment',
  SUBMISSION: 'submission',
};

// Helper function to get the correct domain extension based on current URL
const getInfinityPortalUrl = () => {
  const currentHost = window.location.hostname;
  const isMeDomain = currentHost.includes('.me');
  const domainExtension = isMeDomain ? '.me' : '.ac';
  return `https://infinity.sparkl${domainExtension}`;
};
const getVelocityPortalUrl = () => {
  const currentHost = window.location.hostname;
  const isMeDomain = currentHost.includes('.me');
  const domainExtension = isMeDomain ? '.me' : '.ac';
  return `https://velocity.sparkl${domainExtension}`;
};

export const SPARKL = {
  email: 'test@sparkl.me',
  introVideo:
    'https://asset.sparkl.me/pb/assets/video/mathew_raggett_video.mp4',
  liveClassPortal: getInfinityPortalUrl(),
  SparkyPortal:
    process.env.REACT_APP_AI_SPARKY_PORTAL || 'https://aitutor.sparkl.me/learn',
  SparkyPortalDemo:
    process.env.REACT_APP_AI_SPARKY_PORTAL_DEMO || 'https://aitutor.sparkl.me',
  mobile: '9821518833',
  nonProctorPortal: getVelocityPortalUrl(),

  termsAndConditions: 'https://sparkl.me/terms',
  privacyPolicy: 'https://sparkl.me/policy',
  headerLogoBlack:
    'https://www.sparkl.me/home/static/media/sparkl-header-logo-black.46061ef5228dfdad0d9a3271a015e186.svg',
  
  satMathTextbookId: process.env.REACT_APP_SAT_MATH_TEXTBOOK_ID || 374,
  satEnglishTextbookId: process.env.REACT_APP_SAT_ENGLISH_TEXTBOOK_ID || 375,
};

export const TEST_STATUS = {
  COMPLETED: 'completed',
  NOT_ASSIGNED: 'not assigned',
  PENDING: 'pending',
};

export const BREAKPOINTS = {
  xl: 1536,
  lg: 1366,
  md: 992,
  sm: 767,
  xs: 576,
};

export const MUI_MOBILE_BREAKPOINT = 600;

export const USER_TYPE = {
  STUDENT: 'student',
};

export const DEFAULT_OTP_LENGTH = 4;

/**
 * Login mobile input (max 17 chars):
 * - normal digits (e.g. 9876543210)
 * - digits with any special characters (e.g. #**1234567890**#)
 * Letters and whitespace are not allowed.
 */
export const MOBILE_NUMBER_INPUT = {
  MIN_LENGTH: 4,
  MAX_LENGTH: 17,
  /** Digits + specials; no letters or whitespace */
  SINGLE_CHAR_REGEX: /[^A-Za-z\s]/,
} as const;

const MOBILE_NUMBER_ALLOWED_REGEX = /^[^A-Za-z\s]+$/;
/** At least 4 digits somewhere in the value */
const MOBILE_NUMBER_HAS_DIGITS_REGEX = /\d{4,}/;

export const isMobileNumberInputValid = (value: string): boolean =>
  value.length >= MOBILE_NUMBER_INPUT.MIN_LENGTH &&
  value.length <= MOBILE_NUMBER_INPUT.MAX_LENGTH &&
  MOBILE_NUMBER_ALLOWED_REGEX.test(value) &&
  MOBILE_NUMBER_HAS_DIGITS_REGEX.test(value);

export const OTP_TIMER_IN_SECONDS = {
  RESEND: 30,
  BLOCK_USER: 120,
};

export const LOGOUT = 'logout';
export const PROFILE = 'profile';
export const SAT_REDIRECT = 'sat_redirect';
export const ACT_REDIRECT = 'act_redirect';
export const SAT_COURSE_ID = 75;
export const SAT_SUBSCRIBED = 'sat_subscribed';
export const ASYNC_SAT_REDIRECT = 'async_sat_redirect';

export const SESSION_STATUS = {
  NOT_STARTED: 0,
  ONGOING: 1,
  COMPLETED: 2,
  CANCELED: 3,
};

export const MENU_ORIENTATION = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

export const MODAL_ANIMATION_TYPE = {
  NORMAL: 'normal',
  SCALE: 'scale',
};

export const TOAST_DURATION = 2000;

export const DOM_ELEMENTS = {
  CROP_VIEW_CONTAINER: 'crop-view-container',
  SCAN_CONTAINER: 'scan-container',
};

export const DOCUMENT_SCAN_CODES = {
  NOTHING_DETECTED: 'Error_NothingDetected',
};

export const SPARKL_MOBILE_APP = {
  PLAY_STORE: 'https://play.google.com/store/apps/details?id=me.sparkl.student',
  APP_STORE: 'https://apps.apple.com/us/app/sparkl-learning/id6505143381',
};

export const ASSIGNMENT_STATUS_NUMBER = {
  PENDING: 1,
  SUBMITTED: 2,
  COMPLETED: 3,
};

export const LIVE_TEST_VIEW = {
  TEST: 'test',
  SUBMISSION: 'submission',
};


export const SESSION_TYPE = {
  CLASSROOM: 'classroom',
  PROCTOR_TEST: 'proctor_test',
  NON_PROCTOR_TEST: 'non_proctor_test',
  EXTRA_CLASS: 'extra_class',
  DEMO_CLASSS: 'demo_class',
};

export const SESSION_TYPES_CODES = {
  CONCEPT_CLASS: 1,
  REVISION_CLASS: 2,
  HOLISTIC_WELLBEING: 3,
  PROCTORED_TEST: 4,
  DEMO_CLASS: 5,
  SPARKY_ASSIGNMENT_SESSION: 6,
  SPARKY_PRACTICE_SESSION: 7,
  SPARKY_CONCEPT_SESSION: 8,
};

export const TO_RADIANS = Math.PI / 180;

export const STATUS_CONFIG = ({ status }: { status: string }) => {
  switch (status) {
    case 'new': {
      return {
        text: 'New',
        icon: newIcon,
        backgroundColor: '#FDCA59',
        textColor: '#1A1A1A',
        backgroundColorOfIcon:
          'linear-gradient(180deg, #FDCA59 0%, #EC9201 100%)',
      };
    }

    case 'pending': {
      return {
        text: 'Pending',
        icon: pendingIcon,
        backgroundColor: '#E03C31',
        textColor: '#fff',
        backgroundColorOfIcon:
          'linear-gradient(0deg, #FF5658 0%, #FFDB5B 100%), linear-gradient(180deg, rgba(255, 255, 255, 0.09) 0%, rgba(255, 255, 255, 0.30) 100%)',
      };
    }
    case 'evaluated': {
      return {
        text: 'Evaluated',
        icon: evaluatedIcon,
        backgroundColor: '#046BCB',
        textColor: '#fff',
        backgroundColorOfIcon:
          'linear-gradient(180deg, #A8E2FF 0%, #046BCB 100%), linear-gradient(180deg, rgba(255, 255, 255, 0.09) 0%, rgba(255, 255, 255, 0.30) 100%)',
      };
    }
    case 'submitted': {
      return {
        text: 'Submitted',
        icon: submittedIcon,
        backgroundColor: '#008578',
        textColor: '#fff',
        backgroundColorOfIcon:
          'linear-gradient(180deg, #10FD6F 0%, #017B32 100%)',
      };
    }
    case 'missed': {
      return {
        text: 'Missed',
        icon: missedIcon,
        backgroundColor: '#808080',
        textColor: '#fff',
        backgroundColorOfIcon:
          "linear-gradient(0deg, #1A1A1A 0%, #808080 100%)'",
      };
    }

    default: {
      return {
        text: 'New',
        icon: newIcon,
        backgroundColor: '#FDCA59',
        textColor: '#1A1A1A',
        backgroundColorOfIcon:
          'linear-gradient(180deg, #FDCA59 0%, #EC9201 100%)',
      };
    }
  }
};

export const drawerWidth = 232;
export const tabDrawerWidth = 78;

export const SPARKY_SESSION_STATUS = {
  START_SESSION: 0,
  RESUME_SESSION: 1,
  COMPLETED: 2,
  CANCELED: 3,
};

export const SPARKY_SESSION_TYPE = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  ALL: 'all',
};

export const SORT_BY = {
  ASC: 'asc',
  DESC: 'desc',
}